<template>
  <v-form
    id="activateForm"
    ref="activateForm"
  >
    <v-card-text>
      <PolteqTextField
        v-model="username"
        field-id="usernameField"
        :label="i18n.t('fields.username')"
        :rules="[rules.email]"
        type="email"
        autocomplete="username"
        icon="mdi-email-outline"
      />
      <PolteqTextField
        v-model="password"
        field-id="passwordField"
        :label="i18n.t('fields.password')"
        :rules="[rules.required]"
        type="password"
        autocomplete="current-password"
        icon="mdi-lock-outline"
      />
      <PolteqTextField
        v-model="activationCode"
        field-id="activationCodeField"
        :label="i18n.t('fields.activationCode')"
        :rules="[rules.required]"
        type="text"
        icon="mdi-form-textbox-password"
      />
    </v-card-text>
    <v-card-text style="text-align: end">
      <PolteqButton
        button-id="loginButton"
        icon="mdi-login-variant"
        :button-text="i18n.t('buttons.signin')"
        @click="activate(username, password, activationCode)"
      />
      <br>
      <PolteqButton
        button-id="forgotPasswordButton"
        icon="mdi-lock-question"
        :button-text="i18n.t('texts.forgotpassword')"
        @click="NavigationHelper.openForm(router, Forms.FORGOT_PASSWORD)"
      />
    </v-card-text>
  </v-form>
</template>

<script lang="ts" src="./ActivateForm.ts" />
